import {Component, NgModule, AfterViewInit, ViewChild, OnInit } from '@angular/core';
import { FooterModule } from '../footer/footer';
import { HeaderModule } from '../header/header';

import { CommService } from '../comm.service';
import { Minichat } from '../minichat/minichat.component';
import { MinichatModule } from '../minichat/minichat.component';

import { HttpClient } from "@angular/common/http";
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.html',
  styleUrls: ['./contact.scss']
})
export class Contact implements OnInit {

  public commService: any;
  //@ViewChild('chat1', {static:false}) chat1: Minichat;

  constructor() { //private http: HttpClient) {

  }

  ngOnInit() {
    
    //this.home1.setNavbar(this.navbar);
    //this.chatbox1.setComm(this.commService);
  }
}

@NgModule({
  imports: [FooterModule, HeaderModule, MinichatModule, MatButtonModule],
  exports: [Contact],
  declarations: [Contact],
})
export class ContactModule {}